import { Fragment, useEffect, useState } from "react";
import { ChevronDown, ChevronRight, Download } from "lucide-react";
import { Modal } from "../lib/ui";
import { api, moneyCur, download } from "../lib/api";

const fmt = (a, v) => moneyCur(v, a.currency, a.gold_unit);
const sign = (v) => (v < 0 ? "negative" : "");

function DetailRows({ a }) {
  return a.months.filter((m) => !m.future).map((m) => (
    <tr key={m.month} className="as-detail" data-testid={`as-detail-${a.id}-${m.month}`}>
      <td>{m.label}</td>
      <td colSpan={13}>
        <span>Devreden <b className={sign(m.opening)}>{fmt(a, m.opening)}</b></span>
        <span>Giriş <b className="positive">+{fmt(a, m.in)}</b></span>
        <span>Çıkış <b className="negative">-{fmt(a, m.out)}</b></span>
        <span>Ay sonu <b className={sign(m.closing)}>{fmt(a, m.closing)}</b></span>
      </td>
    </tr>
  ));
}

export function AccountSummaryModal({ onClose }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const [data, setData] = useState(null);
  const [open, setOpen] = useState({});
  const [error, setError] = useState("");
  useEffect(() => {
    setData(null); setError("");
    api.get("/accounts/monthly-summary", { params: { year } }).then((r) => setData(r.data)).catch((e) => setError(e.response?.data?.detail || "Yüklenemedi"));
  }, [year]);
  const years = Array.from({ length: 8 }, (_, i) => new Date().getFullYear() - i);
  const months = data?.[0]?.months || [];
  return (
    <Modal title="Hesap özeti" eyebrow="RAPOR" size="full" onClose={onClose} testid="account-summary-modal"
           subtitle="Kasa ve banka hesaplarının ay sonu bakiyeleri · ayrıntı için hesaba tıklayın">
      <div className="bi-toolbar">
        <select value={year} data-testid="as-year" onChange={(e) => setYear(Number(e.target.value))}>
          {years.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
        <div className="button-row">
          <button className="secondary-button" data-testid="as-export-pdf" onClick={() => download(`/accounts/monthly-summary?year=${year}&fmt=pdf`, `hesap-ozeti-${year}.pdf`)}><Download size={14} /> PDF</button>
          <button className="secondary-button" data-testid="as-export-xlsx" onClick={() => download(`/accounts/monthly-summary?year=${year}&fmt=xlsx`, `hesap-ozeti-${year}.xlsx`)}><Download size={14} /> Excel</button>
        </div>
      </div>
      {error && <div className="form-error">{error}</div>}
      {!data && !error && <p className="muted">Yükleniyor…</p>}
      {data && (
        <div className="bi-table-wrap">
          <table className="bi-table as-table" data-testid="as-table">
            <thead><tr><th>Hesap</th>{months.map((m) => <th key={m.month} className="amount">{m.label}</th>)}</tr></thead>
            <tbody>
              {data.map((a) => (
                <Fragment key={a.id}>
                  <tr className="clickable-row" data-testid={`as-row-${a.id}`} onClick={() => setOpen((o) => ({ ...o, [a.id]: !o[a.id] }))}>
                    <td><strong className="as-name">{open[a.id] ? <ChevronDown size={13} /> : <ChevronRight size={13} />} {a.name}</strong></td>
                    {a.months.map((m) => (
                      <td key={m.month} className={`amount ${m.future ? "" : sign(m.closing)}`} data-testid={`as-cell-${a.id}-${m.month}`}>
                        {m.future ? "—" : fmt(a, m.closing)}
                      </td>
                    ))}
                  </tr>
                  {open[a.id] && <DetailRows a={a} />}
                </Fragment>
              ))}
            </tbody>
          </table>
          {!data.length && <div className="empty-module full"><strong>Görüntülenecek hesap yok</strong></div>}
        </div>
      )}
    </Modal>
  );
}
